import {RouteConfig} from 'vue-router';

const LazyCategories = () => (
  import(/* webpackChunkName: "home" */ '@/components/Categories')
);

export const categoriesRouter: RouteConfig[] = [
  {
    path: ':categorySlug?',
    name: 'category-with-slug',
    component: LazyCategories,
  },
];
